var $ = require('jquery');
var DocNote = require('../document');

module.exports = DocNote.extend({
    desc: "Activity",
    actionTitle: 'Activity',
    iconClass: 'icon-clipboard',
    init: 'A',
    notCreatable: true
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/document/noteTypes/activity.js
 ** module id = 284
 ** module chunks = 0
 **/